<div class="top-section border-none mb-16px">
    <div class="flex items-center relative">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8">
        </app-svg>

        <!-- Show Mevolve logo when all features are disabled OR only non-date features (Note/List) are enabled -->
        <ng-container *ngIf="featureStore.allFeaturesDisabled() || featureStore.onlyNonDateFeaturesEnabled()">
            <div class="flex-1 flex justify-center">
                <app-svg [name]="brandLogo" [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"
                    [height]="'24px'"></app-svg>
            </div>
        </ng-container>

        <!-- Trigger - only show when date-based features are enabled -->
        <div role="button" class="flex" (click)="openCalendar()" #calendarTrigger
            *ngIf="!featureStore.allFeaturesDisabled() && !featureStore.onlyNonDateFeaturesEnabled()">
            <h4 class="heading mb-0">{{ ss.getFormattedDate(dateString(), 'MMM y') }}</h4>
            <app-svg name="downArrow" class="ri-ms-2" role="button"
                [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
        </div>

        <mat-form-field class="hidden-input"
            *ngIf="!featureStore.allFeaturesDisabled() && !featureStore.onlyNonDateFeaturesEnabled()">

            <input matInput [matDatepicker]="picker" [value]="dateString()"
                (dateChange)="dateSelected($event, picker)" />

            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>

            <mat-datepicker #picker [calendarHeaderComponent]="entityCalendarHeader"
                panelClass="custom-datepicker-panel sm:w-full">
                <ng-template #calendarFooter>
                    <div class="flex justify-center entity-calendar-footer">
                        <p>{{ periodLabel || ss.getFormattedDate(dateString(), 'MMMM y') }}</p>
                    </div>
                </ng-template>
            </mat-datepicker>

        </mat-form-field>

    </div>

    <div class="flex items-center gap-6">

        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>

        <!-- <button class="btn text-14-400 mb-0 flex items-center unscheduled-button"
            [ngClass]="cc.isNarrowScreen() ? 'color-12' : 'color-8'"
            *ngIf="ss.viewSignals()['showTodoFeature']() && !featureStore.allFeaturesDisabled() && (todoStore.unscheduledUncompletedTodosCount() > 0 || todoStore.unscheduledcompletedTodosCount() > 0 || todoStore.unscheduledSkippedTodosCount() > 0)"
            (click)="openUnscheduledTodos()">
            <span class="icon-circle-dash"></span>
            <span class="icon-count" *ngIf="todoStore.unscheduledUncompletedTodosCount() > 0">
                {{
                todoStore.unscheduledUncompletedTodosCount() > 9
                ? '9+'
                : todoStore.unscheduledUncompletedTodosCount()
                }}
            </span>
        </button> -->
        <app-svg name="more" class="more-icon" role="button"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"
            *ngIf="!featureStore.allFeaturesDisabled()" (click)="openKebabMenu()"></app-svg>

    </div>
</div>

<!-- Hide breadcrumb/week selector when all features are disabled OR only non-date features (Note/List) are enabled -->
@if (!featureStore.allFeaturesDisabled() && !featureStore.onlyNonDateFeaturesEnabled()) {

<!-- Mobile Weekly Calendar (< 750px) - with swipe gestures -->
@if (cc.isNarrowScreen()) {
<div class="mobile-calendar-wrapper">
    <app-mobile-weekly-calendar [weekDays]="weekDays()" (daySelected)="onMobileDaySelected($event)"
        (navigateWeek)="onMobileNavigateWeek($event)" (openMonthCalendar)="onMobileOpenMonthCalendar()">
    </app-mobile-weekly-calendar>
</div>
}

<!-- Desktop Week Selector (>= 750px) - with arrow buttons -->
@if (!cc.isNarrowScreen()) {
<div class="flex justify-between items-center ri-px-4 ri-pb-2 breadcrumb-block w-full">
    <div class="flex items-center w-full justify-around">

        <app-svg name="chevronLeft" role="button" (click)="slideAndNavigate(-7)" [color]="ss.theme().color8"
            class="cursor-pointer hover:opacity-70 transition-opacity icon-mirror-rtl">
        </app-svg>

        <!-- Week Wrapper (ANIMATED) -->
        <div class="week-wrapper" [ngClass]="slideDirection">
            <div class="flex justify-between flex-1 ri-w-full relative flex-wrap day-wrapper">
                <!-- ✅ UPDATED: Using signal with trackBy -->
                <ng-container *ngFor="let day of weekDays(); trackBy: trackByDate">
                    <div class="relative flex flex-col items-center flex-shrink-0 cursor-pointer rounded day-item">

                        <div [ngClass]="[
                                    day.active ? 'breadcrumb-active font-600' : 'breadcrumb-nonactive',
                                    day.isToday ? 'breadcrumb-today' : ''
                                ]"
                            class="flex flex-row items-center justify-center text-14-400 py-1 rounded transition-all breadcrumb-day text-center"
                            (click)="selectDay(day)">

                            <div class="day-name">{{ day.name }}</div>
                            <div class="ms-1 text-[13px] day-number">
                                {{ day.date }}
                            </div>
                        </div>

                        <!-- ✅ Data dot - will update automatically when hasData changes -->
                        <div *ngIf="day.hasData" class="data-dot absolute bottom-[-6px]"></div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Right Arrow -->
        <app-svg name="chevronRight" role="button" (click)="slideAndNavigate(7)" [color]="ss.theme().color8"
            class="cursor-pointer hover:opacity-70 transition-opacity icon-mirror-rtl">
        </app-svg>

    </div>
</div>
}
}

<div class="body-section position-relative" [ngClass]="bodySlideDirection()">
    <div class="goal-block bg-5" *ngIf="viewSettings.showUserGoal()">
        <p class="text-16-400 color-35 mb-0 ri-p-4 ri-bb-2 text-center" role="button" (click)="openGoal()">{{
            viewSettings.userGoal() || ss.t('common_yourGoal') }}</p>
    </div>
    <div class="entities-block" [ngClass]="{'with-goal': viewSettings.showUserGoal()}">
        <ng-container *ngIf="!viewSettings.showCalendarView()">
            <ng-container
                *ngIf="viewSettings.entityGroupBy() === 'chronological' && (entries().withTime.length !== 0 || entries().withoutTime.length !== 0)">
                <!-- === SCHEDULED ENTITIES (always fully expanded) === -->
                <!-- Timeline at top: show when current time is before all items -->
                <!-- Match Flutter: hide at first position only if labels are disabled (visual alignment) -->
                <div class="time-line time-line-bottom"
                    *ngIf="isToday() && viewSettings.showTimebox() && timelineIndex() === 0 && entries().withTime.length > 0 && viewSettings.entityShow().includes('label')">
                    <span class="time-line-time">{{ ss.getFormattedDate(currentTime(), 'hh:mm a') }}</span>
                </div>
                <ng-container *ngIf="entries().withTime.length !== 0">
                    <ng-container
                        *ngTemplateOutlet="entitiesBlock; context: { $implicit: entries().withTime, groupId: 'withTime' }"></ng-container>
                </ng-container>
                <!-- Timeline at end of withTime list: show when current time is after all timed items -->
                <div class="time-line time-line-middle"
                    *ngIf="isToday() && viewSettings.showTimebox() && timelineIndex() === entries().withTime.length && entries().withTime.length > 0">
                    <span class="time-line-time">{{ ss.getFormattedDate(currentTime(), 'hh:mm a') }}</span>
                </div>

                <!-- === ALL-DAY CALENDAR EVENTS (not grouped, rendered as flat list) === -->
                <ng-container *ngIf="allDayCalendarEvents().length !== 0">
                    <ng-container
                        *ngTemplateOutlet="entitiesBlock; context: { $implicit: allDayCalendarEvents(), groupId: 'allDayCalendar' }"></ng-container>
                </ng-container>

                <!-- === SCHEDULED WITHOUT TIME (always expanded, no grouping) === -->
                <!-- Scheduled entities that have no startTime (e.g., daily habits with no specific time). -->
                <!-- Matches Flutter behavior: classified by isScheduled flag, not by time presence. -->
                <ng-container *ngIf="scheduledWithoutTime().length !== 0">
                    <ng-container
                        *ngTemplateOutlet="entitiesBlock; context: { $implicit: scheduledWithoutTime(), groupId: 'scheduledWithoutTime' }"></ng-container>
                </ng-container>

                <!-- === UNSCHEDULED ENTITIES (grouped with expand/collapse) === -->
                @for (group of unscheduledDisplayGroups(); track group.category) {
                    @if (group.state === 'auto-expanded') {
                        <!-- Auto-expanded: no header, items show directly like normal list items -->
                        <ng-container
                            *ngTemplateOutlet="entitiesBlock; context: { $implicit: group.entities, groupId: 'unscheduled-' + group.category }"></ng-container>
                    } @else if (group.state === 'collapsed') {
                        <!-- Collapsed: header tile only, tappable to expand -->
                        <div class="collapsed-group-tile ri-bb-2" (click)="toggleGroup(group.category)" role="button">
                            <span class="text-16-500 color-35">{{ group.name }}</span>
                            <span class="collapsed-group-badge text-10-500 color-12">{{ group.count }}</span>
                        </div>
                    } @else {
                        <!-- User-opened: header tile (expanded bg) + items below, tappable to collapse -->
                        <div class="collapsed-group-tile collapsed-group-tile--expanded ri-bb-2" (click)="toggleGroup(group.category)" role="button">
                            <span class="text-16-500 color-8">{{ group.name }}</span>
                            <span class="collapsed-group-badge text-10-500 color-12">{{ group.count }}</span>
                        </div>
                        <ng-container
                            *ngTemplateOutlet="entitiesBlock; context: { $implicit: group.entities, groupId: 'unscheduled-' + group.category }"></ng-container>
                    }
                }
            </ng-container>

            <ng-container
                *ngIf="viewSettings.entityGroupBy() === 'category' && (entries().withTime.length !== 0 || entries().withoutTime.length !== 0)">
                <ng-container *ngFor="let group of groupByFeatures();let i = index;">
                    <div class="text-16-400 color-35 ri-px-4 ri-py-3 ri-bb-2" [style.background]="'var(--color6)'"
                        [style.border-radius]="!cc.isNarrowScreen() ? '8px' : null"
                        [attr.isOpen]="true" #tgroupHead>
                        {{ group.name }}
                    </div>
                    <ng-container
                        *ngTemplateOutlet="entitiesBlock; context: { $implicit: group.data, groupId: 'entityGroup' + i }"></ng-container>
                </ng-container>
            </ng-container>

            <ng-template #entitiesBlock let-element let-groupId="groupId">
                @for (entry of element; track (entry.setupId + '_' + entry.date + '_' + entry.dayIndex + '_' + (entry.actionId || '') + '_' + (entry.scheduleId || '')); let i = $index) {
                    @switch (entry.entityType) {
                        @case ('todo') {
                            <app-todo-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [show]="viewSettings.entityShow()" [entry]="entry" [dateString]="dateString()"
                                [descriptionType]="viewSettings.entityDescriptionType()"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-todo-block>
                        }
                        @case ('habit') {
                            <app-habit-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [show]="viewSettings.entityShow()" [dateString]="dateString()" [entry]="entry"
                                [descriptionType]="viewSettings.entityDescriptionType()"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-habit-block>
                        }
                        @case ('journal') {
                            <app-journal-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [show]="viewSettings.entityShow()" [dateString]="dateString()" [entry]="entry"
                                [descriptionType]="viewSettings.entityDescriptionType()"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-journal-block>
                        }
                        @case ('moneyTracker') {
                            <app-money-tracker-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [show]="viewSettings.entityShow()" [entry]="entry"
                                [descriptionType]="viewSettings.entityDescriptionType()" [isSetup]="true"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-money-tracker-block>
                        }
                        @case ('calendarIntegration') {
                            <app-calendar-event-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [entry]="entry" [show]="viewSettings.entityShow()" [dateString]="dateString()"
                                [descriptionType]="viewSettings.entityDescriptionType()"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-calendar-event-block>
                        }
                        @case ('focus') {
                            <app-focus-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [show]="viewSettings.entityShow()" [entry]="entry"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"
                                [dateString]="dateString()"></app-focus-block>
                        }
                        @case ('note') {
                            <app-note-block class="ri-bb-2 entity-block" [blockClass]="'ri-px-4 ri-py-3'"
                                [noteId]="entry.setupId" [show]="viewSettings.entityShow()"
                                [descriptionType]="viewSettings.entityDescriptionType()"
                                [isLabel]="viewSettings.entityGroupBy() === 'chronological'"></app-note-block>
                        }
                    }
                    <!-- Timeline between items: show after item i when timelineIndex === i + 1 -->
                    <!-- Only show within withTime group, not after the last item (that's handled separately) -->
                    @if (isToday() && viewSettings.showTimebox() && groupId === 'withTime' && timelineIndex() === i + 1 && timelineIndex() < entries().withTime.length) {
                        <div class="time-line time-line-middle">
                            <span class="time-line-time">{{ ss.getFormattedDate(currentTime(), 'hh:mm a') }}</span>
                        </div>
                    }
                }
            </ng-template>

            <div *ngIf="viewSettings.hideCompletedItems() && entries().completedEntries.length > 0"
                class="ri-py-4 text-center toggle-completed-block">
                <span class="text-12-400 color-7 flex items-center justify-center"
                    (click)="featureStore.filter().hideCompleted.set(!featureStore.filter().hideCompleted())"
                    role="button">{{ featureStore.filter().hideCompleted() ?
                    ss.t('today_showCompletedContext') : ss.t('common_hideCompletedContext')
                    }} <span class="completed-count-badge">{{ entries().completedEntries.length
                        }}</span></span>
            </div>

            <!-- Show all-features-disabled empty state when all features are turned off -->
            <app-all-features-disabled-block
                *ngIf="featureStore.allFeaturesDisabled()"></app-all-features-disabled-block>

            <!-- Show regular no-result block when some features are enabled but no data for this day -->
            <app-no-result-block
                *ngIf="!featureStore.allFeaturesDisabled() && entries().withTime.length === 0 && entries().withoutTime.length === 0"
                [message]="ss.t('common_emptyContent')"
                [imagePlaceholder]="'featuresPlaceholder'"></app-no-result-block>
        </ng-container>

        <ng-container *ngIf="viewSettings.showCalendarView()">
            <app-entity-calendar [events]="featureStore.calendarViewEvents()" [withoutTimeEvents]="entries().withoutTime"
                [viewDate]="currentDate"
                [dateString]="dateString()"></app-entity-calendar>
        </ng-container>
    </div>
</div>

<!-- Bottom Bar (all screen sizes) -->
@if (!featureStore.allFeaturesDisabled()) {
<app-mobile-bottom-bar></app-mobile-bottom-bar>
}
